import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const InputField = () => {
  const [value1, setValue1] = useState("");
  const [value2, setValue2] = useState("");
  const [value3, setValue3] = useState("");
  const [value4, setValue4] = useState("");

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* NORMAL INPUTS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Normal Inputs</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Input 1 */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Default Input</label>
              <input type="text" placeholder="Enter text..." value={value1} onChange={(e) => setValue1(e.target.value)} className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100 placeholder-slate-500 focus:border-amber-400 focus:outline-none focus:ring-1 focus:ring-amber-400 transition-colors" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" placeholder="Enter text..." className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100 placeholder-slate-500 focus:border-amber-400 focus:outline-none focus:ring-1 focus:ring-amber-400" />`} />
          </div>

          {/* Input 2 */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">With Icon</label>
            <div className="relative">
              <input type="email" placeholder="email@example.com" className="w-full px-3 py-2 pl-8 bg-slate-800 border border-slate-600 rounded text-slate-100 placeholder-slate-500 focus:border-amber-400" />
              <span className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-slate-400"></span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <input type="email" placeholder="email@example.com" className="w-full px-3 py-2 pl-8 bg-slate-800 border border-slate-600 rounded" />
  <span className="absolute left-2.5 top-1/2 transform -translate-y-1/2"></span>
</div>`} />
          </div>

          {/* Input 3 */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Search Input</label>
            <input type="search" placeholder="Search..." className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100 focus:border-blue-500" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="search" placeholder="Search..." className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded focus:border-blue-500" />`} />
          </div>

          {/* Input 4 */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Password Input</label>
            <input type="password" placeholder="" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="password" placeholder="" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded" />`} />
          </div>

          {/* Input 5 */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Number Input</label>
            <input type="number" placeholder="0" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="number" placeholder="0" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded" />`} />
          </div>

          {/* Input 6 */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Date Input</label>
            <input type="date" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="date" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded" />`} />
          </div>
        </div>
      </div>

      {/* VALIDATION STATES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Validation States</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Success */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-emerald-400 mb-2 block"> Success</label>
            <input type="text" defaultValue="Valid input" className="w-full px-3 py-2 bg-slate-800 border-2 border-emerald-500 rounded text-slate-100 focus:outline-none" />
            <p className="text-xs text-emerald-400 mt-1">Perfect! All good.</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-3 py-2 bg-slate-800 border-2 border-emerald-500 rounded" />`} />
          </div>

          {/* Error */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-red-400 mb-2 block"> Error</label>
            <input type="text" placeholder="Invalid input" className="w-full px-3 py-2 bg-slate-800 border-2 border-red-500 rounded text-slate-100" />
            <p className="text-xs text-red-400 mt-1">This field is required</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-3 py-2 bg-slate-800 border-2 border-red-500 rounded" />`} />
          </div>

          {/* Warning */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-amber-400 mb-2 block"> Warning</label>
            <input type="text" defaultValue="Use with caution" className="w-full px-3 py-2 bg-slate-800 border-2 border-amber-500 rounded text-slate-100" />
            <p className="text-xs text-amber-400 mt-1">This might need review</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-3 py-2 bg-slate-800 border-2 border-amber-500 rounded" />`} />
          </div>

          {/* Info */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-blue-400 mb-2 block">? Info</label>
            <input type="text" placeholder="Information" className="w-full px-3 py-2 bg-slate-800 border-2 border-blue-500 rounded text-slate-100" />
            <p className="text-xs text-blue-400 mt-1">Additional information</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-3 py-2 bg-slate-800 border-2 border-blue-500 rounded" />`} />
          </div>

          {/* Disabled */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-500 mb-2 block">Disabled Input</label>
            <input type="text" defaultValue="Disabled" disabled className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded text-slate-500 cursor-not-allowed" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" disabled className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded text-slate-500 cursor-not-allowed" />`} />
          </div>

          {/* Loading */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Loading State</label>
            <div className="relative">
              <input type="text" placeholder="Loading..." className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100" />
              <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-slate-400 animate-spin"></span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <input type="text" className="w-full px-3 py-2..." />
  <span className="absolute right-2 top-1/2 animate-spin"></span>
</div>`} />
          </div>
        </div>
      </div>

      {/* SIZES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Input Sizes</h2>
        <div className="space-y-3">
          {/* Small */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Small</label>
            <input type="text" placeholder="Small input..." className="w-full px-2 py-1 text-sm bg-slate-800 border border-slate-600 rounded text-slate-100" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-2 py-1 text-sm bg-slate-800 border border-slate-600 rounded" />`} />
          </div>

          {/* Medium */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Medium (Default)</label>
            <input type="text" placeholder="Medium input..." className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded" />`} />
          </div>

          {/* Large */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Large</label>
            <input type="text" placeholder="Large input..." className="w-full px-4 py-3 text-lg bg-slate-800 border border-slate-600 rounded text-slate-100" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-4 py-3 text-lg bg-slate-800 border border-slate-600 rounded" />`} />
          </div>

          {/* Extra Large */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Extra Large</label>
            <input type="text" placeholder="Extra large input..." className="w-full px-5 py-4 text-xl bg-slate-800 border border-slate-600 rounded text-slate-100" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-5 py-4 text-xl bg-slate-800 border border-slate-600 rounded" />`} />
          </div>
        </div>
      </div>

      {/* ADVANCED */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6"> Advanced Variants</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Rounded Full */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Fully Rounded</label>
            <input type="text" placeholder="Rounded input..." className="w-full px-4 py-2 bg-slate-800 border border-slate-600 rounded-full text-slate-100 focus:border-amber-400" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-4 py-2 bg-slate-800 border border-slate-600 rounded-full" />`} />
          </div>

          {/* No Border */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Borderless</label>
            <input type="text" placeholder="No border..." className="w-full px-3 py-2 bg-slate-800 text-slate-100 focus:outline-none" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-3 py-2 bg-slate-800 focus:outline-none" />`} />
          </div>

          {/* Shadow */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">With Shadow</label>
            <input type="text" placeholder="Shadow input..." className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded shadow-lg shadow-amber-400/30 text-slate-100 focus:border-amber-400" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded shadow-lg shadow-amber-500/30" />`} />
          </div>

          {/* Gradient Border */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Gradient Border</label>
            <div className="p-0.5 bg-gradient-to-r from-amber-500 to-blue-500 rounded">
              <input type="text" placeholder="Gradient..." className="w-full px-3 py-2 bg-slate-800 text-slate-100 focus:outline-none" />
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-0.5 bg-gradient-to-r from-amber-500 to-blue-500 rounded">
  <input type="text" className="w-full px-3 py-2 bg-slate-800" />
</div>`} />
          </div>

          {/* Animated Focus */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">Animated Focus</label>
            <input type="text" placeholder="Hover me..." className="w-full px-3 py-2 bg-slate-800 border-2 border-slate-600 rounded text-slate-100 hover:border-amber-400 focus:border-amber-400 transition-all duration-300" />
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="text" className="w-full px-3 py-2 bg-slate-800 border-2 border-slate-600 rounded hover:border-amber-400 focus:border-amber-400 transition-all" />`} />
          </div>

          {/* With Label */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-2 block">With Label Above</label>
            <div>
              <label className="block text-xs text-slate-300 font-medium mb-1">Email Address</label>
              <input type="email" placeholder="your@email.com" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded text-slate-100" />
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<label className="block text-xs text-slate-300 font-medium mb-1">Email</label>
<input type="email" className="w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded" />`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputField;


